import { useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchLegalPersons } from "../api/legalPersonService";
import { DEFAULT_PAGE_SIZE } from "../utils/constants";
import { usePageTotal } from "./usePageTotal";
/**
 * One page of the legal person register.
 *
 * @param appliedFilters filters the search sends
 * @param buildQuery builds the CQL query of the filters
 * @param pageSize page size
 * @param enabled false while the filters are still being resolved — nothing is
 *   searched and `isWaitingForFilters` is true
 */
export var useLegalPersonData = function (appliedFilters, buildQuery, pageSize, enabled) {
    var _a;
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    if (enabled === void 0) { enabled = true; }
    var ky = useOkapiKy();
    var _b = useState(0), pageOffset = _b[0], setPageOffset = _b[1];
    var resetPageOffset = function () { return setPageOffset(0); };
    var query = buildQuery(appliedFilters);
    var _c = useQuery(
    // Keyed by what is actually sent: the proposer's resolved publisher only
    // labels the filter, it is not part of the request.
    ["legal-persons", query, pageOffset, pageSize], function () {
        return fetchLegalPersons(ky, {
            query: query,
            offset: pageOffset,
            limit: pageSize,
        });
    }, { enabled: enabled }), data = _c.data, isLoading = _c.isLoading, isError = _c.isError, refetch = _c.refetch;
    var legalPersonsData = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    var _d = usePageTotal(data), totalRecords = _d.totalRecords, totalRecordsExact = _d.totalRecordsExact;
    var fetchMoreData = function (offset) {
        setPageOffset(offset);
    };
    return {
        legalPersonsData: legalPersonsData,
        totalRecords: totalRecords,
        /** false when `totalRecords` is the lower bound of a search not counted exactly (DB-928) */
        totalRecordsExact: totalRecordsExact,
        isLoading: isLoading,
        /** true while the search waits for its filters (`enabled` false) — no request is running */
        isWaitingForFilters: !enabled,
        isError: isError,
        refetch: refetch,
        fetchMoreData: fetchMoreData,
        resetPageOffset: resetPageOffset,
        pageOffset: pageOffset,
        pageSize: pageSize,
    };
};
